import React from "react";
import { PlanResponse } from '../../../services/plansGet';
import styles from './NewPlanSelector.module.scss';

interface Props {
  plans: PlanResponse[];
  selectedPlan: PlanResponse | null;
  onSelectPlan: (plan: PlanResponse) => void;
}

const NewPlanSelector = ({ plans, selectedPlan, onSelectPlan }: Props) => {
  return (
    <div className="space-y-4 mb-6">
      {plans.map((plan) => {
        const isSelected = selectedPlan && selectedPlan.uuid === plan.uuid;
        const isPopular = plan.name.includes('Tu Bienestar');

        return (
          <div
            key={plan.uuid}
            className={`${styles.plan} ${isSelected ? styles.selected : ''}`}
            onClick={() => onSelectPlan(plan)}
          >
            {isPopular && <div className={styles.popularBadge}>Más Popular</div>}
            <div className={styles.header}>
              <div>
                <h3 className={styles.title}>{plan.name}</h3>
                <div className={styles.price}>
                  <span className={styles.amount}>$&nbsp;{plan.cost.toLocaleString('es-CO')}</span>
                  {plan.name.includes('Tu Bienestar') && <span className={styles.originalPrice}>$&nbsp;28.000</span>}
                  {plan.name.includes('Tu Tranquilidad') && <span className={styles.originalPrice}>$&nbsp;70.000</span>}
                  {plan.name.includes('Tu Bienestar') && <span className={styles.discount}>-25%</span>}
                  {plan.name.includes('Tu Tranquilidad') && <span className={styles.discount}>-17%</span>}
                </div>
              </div>
              <div className={`${styles.radio} ${isSelected ? styles.selected : ''}`}>
                {isSelected && <div className={styles.dot}></div>}
              </div>
            </div>
            {plan.name.includes('Tu Comienzo') && <p className={styles.description}>Conoce tu estado actual.</p>}
            {plan.name.includes('Tu Bienestar') && <p className={styles.description}>Conoce tu estado y recibe asesoría personalizada durante 3 meses.</p>}
            {plan.name.includes('Tu Tranquilidad') && <p className={styles.description}>Monitorea tu información y recibe asesoría personalizada durante 6 meses.</p>}
          </div>
        );
      })}
    </div>
  );
};

export default NewPlanSelector;
